import {Group, Title, Text, SimpleGrid, Container, useMantineTheme, Stack, Loader, Image, Box, Grid, Chip, Button} from '@mantine/core';
import { ProductCard } from '../Cards';
import useAxios from 'axios-hooks'
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { searchSortedData } from '../../lib/sort';
import { useMediaQuery } from '@mantine/hooks';
import useStore from '../../store/useStore';

export function ProductsByCategory() {
    let { category } = useParams();
    const theme = useMantineTheme();
    let [searchParams, setSearchParams] = useSearchParams();
    let [allLoadedProducts, setAllLoadedProducts] = useState<any[]>([]);
    let [filterdAllProducts, setFiltredAllProducts] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [{ data: allProducts, loading, error }, refetch] = useAxios(
        `${process.env.REACT_APP_API_URL}/posting-products-bycategory/${category}?page=${page}&limit=20`
    )
    const matches = useMediaQuery('(max-width: 36em)');
    const dataStore = useStore((state: any) => state.store);

    useEffect(() => {
        setPage(1);
        setAllLoadedProducts([]);
    }, [category]);

    useEffect(() => {
        if (allProducts && allProducts?.data) {
            setAllLoadedProducts(prev => {
                if (page === 1) {
                    return [...allProducts.data];
                }
                const existingIds = new Set(prev.map(item => item._id));
                const newItems = allProducts.data.filter((item: any) => !existingIds.has(item._id));
                return [...prev, ...newItems];
            });
            setTotalPages(allProducts?.totalPages);
        }
    }, [allProducts, page]);

    useEffect(() => {
        const search = searchParams.get("search");
        if (search && search !== "") {
            let newData = searchSortedData(allLoadedProducts, ["name"], search)
            setFiltredAllProducts(newData)
        } else {
            setFiltredAllProducts(allLoadedProducts)
        }
    }, [searchParams, allLoadedProducts])
    
    const loadMore = () => {
      setPage(page + 1);
    };

    if (error) return <p>Error!</p>
    
    return (
        <Container size="xl" mt={dataStore?.topBar && dataStore?.topBar?.show && dataStore?.topBar?.content !== "" ? 140 : 100}>
            {loading && allLoadedProducts.length === 0
                ? <Stack align='center' justify='center' mt={50}>
                    <Loader color={dataStore?.information?.backgroundColor || "#645cbb"} size="md" type="bars" />
                </Stack>
                : null
            }
            <Group justify='space-between' h={50} my={matches ? 20 : 30} align='center'>
                <Title order={4} ta="right">{category}</Title>
            </Group>

            {filterdAllProducts && filterdAllProducts?.length > 0
                ? <>
                    <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 5, xl: 5 }} spacing="sm" >
                        {filterdAllProducts?.map((item: any, index: number) => (
                            <ProductCard
                                key={index}
                                id={item._id}
                                title={item?.name}
                                image={item?.thumbnail}
                                price={item?.price }
                                priceAfterDiscount={item.priceAfterDiscount}
                                rating={item?.rating}
                            />
                        ))}
                    </SimpleGrid>
                    {page < totalPages
                        ? <Group justify='center' align='center' mt={30}>
                            <Button variant='light' color={dataStore?.information?.backgroundColor || "#645cbb"} onClick={loadMore} loading={loading}>عرض المزيد</Button>
                        </Group>
                        : null
                    }
                </>
                : !loading ? <Stack align='center' justify='center' mt={50}>
                    <Image src={"/shopping-trolley.png"} h={"100px"} w={"100px"} fit='contain' />
                </Stack> : null
            }
        </Container>
    );
}